import { UseQueryExecute } from 'urql';

import { createContext } from '@lyearn/core/utils/context';
import { ContentLockSettings, LanguageEnum, PerformanceStatusEnum } from '@/types/schema';

import { CoursePerformanceFragment } from '../../../graphql/fragments/generated/CoursePerformance';

const COURSE_VIEWER_NAME = 'Course Viewer';

interface CourseViewerContext {
  isPreviewing: boolean;
  isCoverVisible: boolean;
  toggleCover: (nextValue?: boolean) => void;
  toggleCertificate: (nextValue?: boolean) => void;
  courseStatus?: PerformanceStatusEnum;
  contentPerformance: Record<string, CoursePerformanceFragment>;
  lockSettings: Record<string, ContentLockSettings>;
  refetchContentPerformance: UseQueryExecute;
  navigate?: (nextLessonPageId?: string) => void;
  allowNavigation?: boolean;
  renderAsModel?: boolean;
  onLessonChange?: (lessonId: string) => void;
  onScrollPosition?: (position: number) => void;
  scrollPosition?: number;
  previewRootBlockId: string;
  parentEntityId?: string | null;
  journeySessionId?: string | null;
  languageType?: LanguageEnum;
}

export const [CourseViewerContextProvider, useCourseViewerContext] =
  createContext<CourseViewerContext>(COURSE_VIEWER_NAME);
